import { getD1 } from './d1-context'
import type { CommunitySearchResults } from '@/lib/community-search-results'
import {
  communitySearchQuery,
  searchResultsSchema,
} from '@/lib/community-search-results'
import { readBoundedJson } from '@/lib/bounded-json'

export async function ssrCommunitySearch(
  q?: string,
  tag?: string,
): Promise<CommunitySearchResults | null> {
  if (!communitySearchQuery.safeParse({ q, tag }).success) return null
  const query = new URLSearchParams({ q: q!, ...(tag ? { tag } : {}) })
  if (import.meta.env.SSR) {
    const db = getD1()
    if (db) {
      const { searchCommunity } = await import('./commons/community-search')
      const response = await searchCommunity(
        new Request('https://www.horizon-tech.io/api/agents/search?' + query),
        { DB: db.$client } as Parameters<typeof searchCommunity>[1],
      )
      if (response.status === 404) return null
      if (!response.ok) throw new Error('Community search unavailable')
      return searchResultsSchema.parse(await readBoundedJson(response, 128_000))
    }
  }
  if (typeof window === 'undefined')
    throw new Error('Community search storage unavailable')
  const response = await fetch('/api/agents/search?' + query, {
    credentials: 'omit',
    signal: AbortSignal.timeout(20_000),
  })
  if (response.status === 404) return null
  if (!response.ok) throw new Error('Community search unavailable')
  return searchResultsSchema.parse(await readBoundedJson(response, 128_000))
}
